import { Component, OnDestroy, OnInit } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Subject } from 'rxjs';

@Component({
	selector: 'app-show-video',
	templateUrl: './show-video.component.html',
	styleUrls: ['./show-video.component.scss']
})
export class ShowVideoComponent implements OnInit, OnDestroy {
	public data: any = {};
	private atComponentDestroy = new Subject();

	constructor(public config: DynamicDialogConfig) {
		if (this.config.data) {
			this.data = this.config.data;
		}
	}

	ngOnInit(): void {
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next();
		this.atComponentDestroy.unsubscribe();
	}

}
